export function useThemeShapes() {
  const { themeConfig } = useThemeConfig()

  const defaultShapes = computed <Record<string, ComponentShape>>(() => {
    const shape = themeConfig.value?.defaultShape || 'rounded'

    return {
      accordion: shape,
      autocompleteItem: shape,
      avatar: 'full',
      button: shape,
      buttonAction: shape,
      buttonIcon: shape,
      buttonClose: shape,
      card: shape,
      dropdown: shape,
      iconBox: shape,
      input: shape,
      message: shape,
      pagination: shape,
      progress: shape,
      prose: shape,
      tabSlider: shape,
    }
  })

  return {
    defaultShapes,
  }
}
